import React from 'react';
import { getLabelsByLanguage } from '../../../../utilites/util';
import Topup from '../../../../constants/TopupTypes';

interface Props {
  activeSwitch: string;
  handleSwitch: (switchType: string) => void;
}

const SwitchButtons: React.FC<Props> = ({ activeSwitch, handleSwitch }) => {
  const labels = getLabelsByLanguage();

  return (
    <section className="ytope-fieldset__switch d-flex">
      <button
        data-switch={Topup.STANDARD}
        type="button"
        className={activeSwitch === Topup.STANDARD ? 'active' : ''}
        onClick={() => handleSwitch(Topup.STANDARD)}
      >
        {labels.topupStandardSwitch}
      </button>
      <button
        data-switch={Topup.INTERNET}
        type="button"
        className={activeSwitch === Topup.INTERNET ? 'active' : ''}
        onClick={() => handleSwitch(Topup.INTERNET)}
      >
        {labels.topupInternetSwitch}
      </button>
    </section>
  );
};

export default SwitchButtons;
